import React from "react";
import { useEffect, useState } from "react";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";
import UserSummaryService from "services/UserSummaryService";
import CountRenderer from "./CountRenderer";

function UserAdminSummary() {
  const [userCountData, setUserCountData] = useState([]);

  const fetchUserCounts = () => {
    uepClient()
      .get("/user/count")
      .then((res) => {
        const userCountData = res.data;
        setUserCountData(userCountData);
      })
      .catch((err) => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch the data for user summary.
            </span>
          ),
        });
        console.error(err.message);
      });
  };

  useEffect(() => {
    const userSummaryServiceSubscription = UserSummaryService.listen().subscribe(
      fetchUserCounts
    );
    fetchUserCounts();
    return () => {
      userSummaryServiceSubscription.unsubscribe();
    };
  }, []);

  return (
    <div className="admin-tab-content user-summary-content">
{userCountData && userCountData.map((value) => (
        <CountRenderer label={value.group} count={value.count} />
      ))}
    </div>
  );
}

export default WithAlert(UserAdminSummary);
